import React from "react"
import {FieldGlistGroupProps} from "../../../../render/glist/glist-group";

export default function FieldProto_GlistGroupModern(props:FieldGlistGroupProps) {

    // Notice: value may be 'null' (string) because while grouping null value is automatically converted to string

    // const option = this._getOption(value);
    const option        = props.field._getOption(props.data.value)

    const groupColor    = _.get(option, 'color', null);
    const groupName     = _.get(option, 'label', props.field.noValueOptionLabel);

    const groupNameClasses = Classes("ui5-group-by-text-2", {
        ['gd-c-{0}'.f(groupColor)]  : !!groupColor,
        ['text-color-white']        : !groupColor,
    });

    return <div className={groupNameClasses}>{groupName}</div>;

}
